<template>
  <PublicPopup ref="PopupRef" padding="10px 0 0" @close="emit('close')">
    <template #header>
      <div class="custom-popup-header">
        <p class="custom-popup-header__title">
          {{ $t('home-ad-popup-deposit-bonus-popup.title') }}
        </p>
      </div>
    </template>
    <template #content>
      <div class="popup-container chxy-column-c-c">
        <div class="activity-box">
          <div class="title-primtext">
            <div class="title-primtext-content">
              <div class="label">
                {{ $t('home-ad-popup-deposit-bonus-popup.firstRechargeTask') }}
              </div>
              <div class="right-box" @click="handleRefresh">
                <SvgIcon
                  name="public-info_balance_refresh_style-2"
                  fill="var(--public-info_balance_refresh_style-2-theme)"
                  :size="13.5"
                />
                <span class="name">{{ $t('home-ad-popup-deposit-bonus-popup.refresh') }}</span>
              </div>
            </div>
            <div class="title-primtext-bom">
              <span class="info-o-text">
                {{ $t('home-ad-popup-deposit-bonus-popup.exclusiveBonusLine1') }}
              </span>
              <span class="info-o-text">
                {{ $t('home-ad-popup-deposit-bonus-popup.exclusiveBonusLine2') }}
              </span>
            </div>
          </div>
          <div v-if="activities.length > 0">
            <div
              v-for="(item, index) in activities"
              :key="index"
              class="activity-item"
              :class="{ 'even-item': index % 2 === 0 }"
            >
              <div class="activity-icon-container">
                <div class="gold-coin-icon">
                  <img :src="getImageUrlWithCDN_TEST('/activity/wallet.png', 'local')" />
                </div>
              </div>

              <div class="activity-info">
                <div class="activity-title">
                  {{ $t('home-ad-popup-deposit-bonus-popup.firstDepositPrefix')
                  }}{{ item.initial_amount
                  }}{{ $t('home-ad-popup-deposit-bonus-popup.firstDepositMiddle') }}
                  <span class="bonus-amount">{{ formatNumberWithComma(item.bonus) }}</span>
                </div>

                <!-- 自定义进度条组件 -->
                <div class="progress-container">
                  <div class="custom-progress-bar">
                    <div class="custom-progress-track">
                      <div
                        :class="[
                          'custom-progress-portion',
                          { 'progress-full': item.selected == 1 },
                        ]"
                      ></div>
                    </div>
                  </div>
                  <span class="progress-text">
                    {{ item.selected == 1 ? item.initial_amount : 0 }}/{{ item.initial_amount }}
                  </span>
                </div>
              </div>
              <!-- :style="{
            background:
              infoData.can_claim == 0 && item.selected == 0? '#04BE02': item.selected == 0 ? '#000': '#04BE02',
          }" -->
              <!-- :class="['deposit-button', { 'deposit-buttonBg': item.can_claim == 1 }]" -->
              <!-- :style="{
            background: item.selected == 0 && infoData.can_claim == 0 ? '#000' : '#04BE02',
          }" -->
              <VanButton
                size="normal"
                :class="[
                  'deposit-button',
                  { 'can-claim': item.can_claim === 1 },
                  { disabled: item.is_claim === 1 },
                ]"
                @click="handleReceiveClick(item.can_claim, 1)"
              >
                <template v-if="item.is_claim === 0">
                  <span v-if="item.can_claim === 0">
                    {{ $t('home-ad-popup-deposit-bonus-popup.deposit') }}
                  </span>
                  <span v-else-if="item.can_claim === 1">
                    {{ $t('home-ad-popup-deposit-bonus-popup.receive') }}
                  </span>
                </template>
                <template v-else>
                  <span>{{ $t('home-ad-popup-deposit-bonus-popup.received') }}</span>
                </template>
              </VanButton>
            </div>
          </div>
          <div v-else style="margin-top: 100px"><Empty :width="105" :height="105" /></div>
        </div>
        <div class="footer-container">
          <div class="buttons-content">
            <button class="buttons link">
              {{ $t('home-ad-popup-deposit-bonus-popup.history') }}
            </button>
            <button class="buttons">{{ $t('home-ad-popup-deposit-bonus-popup.history') }}</button>
          </div>
          <div class="checkbox-content chxy-row-bt">
            <div class="checkbox-container">
              <input
                v-model="checked"
                class="checkbox"
                type="checkbox"
                :checked="localChecked === 'checked'"
                @change="change"
              />
              <span class="text">{{ $t('home-ad-popup-deposit-bonus-popup.dontShowToday') }}</span>
            </div>
            <div class="checkbox-container">
              <input
                v-model="checked"
                class="checkbox"
                type="checkbox"
                :checked="localChecked === 'checked'"
                @change="change"
              />
              <span class="text">
                {{ $t('home-ad-popup-deposit-bonus-popup.hidePermanently') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </PublicPopup>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { successToast } from '@/utils/toast'
import { formatNumberWithComma } from '@/utils/format.js'
import { firstChargeInfoApi } from '@/api/activity/index'

import { useUserStore } from '@/stores'

const { t } = useI18n()
const userStore = useUserStore()
// 此处退出登录会触发firstChargeInfoApi接口是需要token的，9.20修复该bug
// watch(
//   () => userStore.userInfo.token,
//   () => {
//     ActivityConfiList()
//   }
// )
watch(
  () => userStore.userInfo.token,
  (newToken) => {
    if (!newToken) return
    ActivityConfiList()
  }
)
const PopupRef = ref(null)
const open = () => {
  nextTick(() => {
    PopupRef.value.open()
  })
}
const handlePopupClose = () => {
  PopupRef.value.close()
}

const activities = ref([])
// 首充奖励列表
const ActivityConfiList = async () => {
  // console.log('ActivityConfiList 首充奖励列表')

  try {
    const res = await firstChargeInfoApi()
    activities.value = res.data.list
    // console.log(activities.value, '首充奖励头部')
  } catch (error) {
    return error
  }
}
// ActivityConfiList()

const isRefreshing = ref(false)
const handleRefresh = async () => {
  if (isRefreshing.value) return

  isRefreshing.value = true

  setTimeout(() => {
    successToast(t('home-ad-popup-deposit-bonus-popup.refreshSuccess'))
    isRefreshing.value = false
  }, 480)
}

const emit = defineEmits(['close'])

defineExpose({
  open,
})
</script>

<style lang="scss" scoped>
.custom-popup-header {
  width: 100%;
  height: 24px;
  text-align: center;

  &__title {
    font-size: 15px;
    line-height: 24px;
    color: var(--popup-primary-title);
  }
}

.popup-container {
  .activity-box {
    display: flex;
    width: 100%;
    height: 445px;
    overflow: hidden auto;
    background-color: var(--activity-eventos-child-3-card-bg);
    border-radius: 6px;
    padding: 10px;
    padding-bottom: 0;
    flex-direction: column;
    align-items: center;
  }
  .title-primtext {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
    margin-bottom: 10px;
    padding: 0 4px 6px;
    padding-left: 6px;
    box-sizing: border-box;

    .title-primtext-content {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 12px;
      width: 100%;

      .label {
        flex: 0 0 140px;
        width: 140px;
        min-width: 0;
        font-size: 14px;
        line-height: 1.3;
        color: var(--activity-eventos-child-3-card-title);
        text-align: left;
      }

      .right-box {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        gap: 4px;
        margin-top: 2px;
        cursor: pointer;

        .name {
          font-size: 12px;
          font-weight: 500;
          color: #26744a;
          line-height: 1;
        }
      }
    }

    .title-primtext-bom {
      font-size: 12px;
      line-height: 1.35;
      color: #999;
      text-align: left;

      .info-o-text {
        display: block;
      }
    }
  }

  .activity-item {
    display: flex;
    align-items: center;
    padding: 8px;
    height: 65px;
    font-size: 9ex;
    border-radius: 6px;
  }
  /* 为偶数行设置背景色 */
  .activity-item:nth-child(odd) {
    background: var(--activity-eventos-child-3-bg);
  }

  .activity-icon-container {
    margin-right: 12px;
  }

  .gold-coin-icon {
    width: 45px;
    height: 45px;
  }
  .gold-coin-icon img {
    height: 45px;
    width: 45px;
  }

  .activity-info {
    flex: 1;
    margin-right: 12px;
  }

  .activity-title {
    width: 186px;
    font-size: 12px;
    font-weight: 500;
    color: var(--activity-eventos-child-3-card-value);
    margin-bottom: 8px;
    line-height: 1.2;
    .bonus-amount {
      color: #ffab0b;
    }
  }
  .progress-container {
    position: relative;
    width: 100%;
    margin-bottom: 2px;
  }

  .progress-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 9px;
    color: #ffffff;
    /* z-index: 1; */
    font-weight: 400;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  /* 自定义进度条样式 */
  .custom-progress-bar {
    width: 100%;
    height: 10px;
    border-radius: 3px;
    overflow: hidden;
    position: relative;
  }

  .custom-progress-track {
    width: 100%;
    height: 100%;
    background-color: var(--activity-eventos-child-3-card-progress-bar-bg);
    position: absolute;
    top: 0;
    left: 0;
  }

  .custom-progress-portion {
    height: 100%;
    background-color: var(--activity-eventos-child-3-card-progress-bar-fill);
    border-radius: 3px;
    transition: width 0.3s ease;
    position: absolute;
    top: 0;
    left: 0;
    width: 0; /* 默认宽度为0 */
  }
  .progress-full {
    width: 100%;
  }

  .deposit-button {
    width: 74px !important;
    height: 29px;
    font-size: 9px;
    color: var(--activity-eventos-child-3-card-receber-button-text);
    border-radius: 5px 5px 5px 5px;
    font-weight: 500;
    background-color: var(--activity-eventos-child-3-card-receber-button-bg);
    border: none;

    &.can-claim {
      background-color: var(--activity-eventos-child-3-card-receber-button-bg);
      color: var(--activity-eventos-child-3-card-receber-button-text);
    }
    &.disabled {
      background-color: var(--button-disabled-bg);
      color: var(--button-disabled-text);
      pointer-events: none;
    }
  }
}

.footer-container {
  padding: 10px;
  width: 100%;
  background: #ffffff;
  border-radius: 0 0 10px 10px;

  .buttons-content {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;

    .buttons {
      flex: 1;
      height: 36px;
      font-size: 11px;
      color: #ffffff;
      border-radius: 8px;
      background-color: #26744a;
      border: 1px solid #26744a;

      &.link {
        background-color: transparent;
        color: #26744a;
      }
    }
  }

  .cell-container {
    .cell-item {
      height: 14px;
    }
  }

  .checkbox-content {
    background: #ffffff;

    .checkbox-container {
      display: flex;
      align-items: center;
      gap: 6px;
      border-radius: 5px;

      .checkbox {
        width: 16px;
        height: 16px;
        border: 1px solid #cecece;
        border-radius: 2px;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background: #f5f5f5;
      }
      .checkbox:checked {
        appearance: auto;
        -webkit-appearance: auto;
        -moz-appearance: auto;
      }

      .text {
        width: calc(100% - 21px);
        font-size: 11px;
        color: #666666;
        line-height: 1.1;
      }
    }
  }
}
</style>
